import React, { useState } from 'react';
import PlayerCard from './PlayerCard';
import EnemyPanel from './EnemyPanel';
import ActionBar from './ActionBar';
import Console from './Console';

export default function MobileLayout({ players, enemies, activeTurn, consoleLines, sendCommand, activeChannel, setActiveChannel, inputRef, handleTarget, handlePrefill, startTargeting, targeting, isPro, isProPlus, hasBasicCombat, isDM, isMyTurn, currentUserId }) {
  const [tab, setTab] = useState('players');

  return (
    <div className="mobile-layout">
      <div className="mobile-content">
        {tab === 'players' && (
          <div className={`mobile-players${targeting ? ' targeting' : ''}`}>
            {players.length === 0 ? (
              <div style={{ color: 'var(--text-dim)', padding: 40, textAlign: 'center' }}>
                {localStorage.getItem('session') ? 'No characters. Run !sync' : 'Login first'}
              </div>
            ) : (
              players.map(p => (
                <PlayerCard key={p.discord_id} player={p} isTurn={activeTurn === p.discord_id} onTarget={handleTarget} />
              ))
            )}
          </div>
        )}
        {tab === 'enemies' && <EnemyPanel enemies={enemies} />}
        {tab === 'actions' && (
          <div className="mobile-actions-wrap">
            <ActionBar onCommand={(cmd) => sendCommand(cmd, activeChannel)} onPrefill={handlePrefill} onStartTargeting={startTargeting} isPro={isPro} isProPlus={isProPlus} hasBasicCombat={hasBasicCombat} isDM={isDM} isMyTurn={isMyTurn} />
          </div>
        )}
        {tab === 'console' && (
          <Console consoleLines={consoleLines} sendCommand={sendCommand} activeChannel={activeChannel} setActiveChannel={setActiveChannel} inputRef={inputRef} />
        )}
        {tab === 'backpack' && (
          <div style={{ padding: '16px', overflowY: 'auto', height: '100%' }}>
            {(isDM ? players : players.filter(p => p.discord_id === currentUserId)).map(p => {
              const items = Array.isArray(p.inventory) ? p.inventory.filter(Boolean) : (p.inventory || '').split(',').map(i => i.trim()).filter(Boolean);
              return (
                <div key={p.discord_id} style={{ marginBottom: '16px' }}>
                  <div style={{ color: 'var(--accent)', fontSize: '0.75rem', marginBottom: '8px', borderBottom: '1px solid var(--panel-border)', paddingBottom: '4px' }}>{p.char_name}</div>
                  {items.length > 0 ? items.map((item, i) => (
                    <div key={i} style={{ fontSize: '0.7rem', color: 'var(--text)', padding: '4px 8px', marginBottom: '3px', background: 'rgba(255,255,255,0.02)', borderRadius: '4px', border: '1px solid var(--panel-border)' }}>
                      {item.toLowerCase().includes('potion') ? '🧪' : item.toLowerCase().includes('scroll') ? '📜' : item.toLowerCase().includes('sword') || item.toLowerCase().includes('blade') || item.toLowerCase().includes('dagger') ? '🗡️' : item.toLowerCase().includes('bow') || item.toLowerCase().includes('arrow') ? '🏹' : item.toLowerCase().includes('staff') || item.toLowerCase().includes('wand') ? '🪄' : item.toLowerCase().includes('shield') ? '🛡️' : item.toLowerCase().includes('armor') || item.toLowerCase().includes('plate') || item.toLowerCase().includes('mail') || item.toLowerCase().includes('mantle') ? '🦺' : item.toLowerCase().includes('ring') ? '💍' : item.toLowerCase().includes('helm') || item.toLowerCase().includes('crown') ? '👑' : item.toLowerCase().includes('boot') || item.toLowerCase().includes('stride') ? '👢' : item.toLowerCase().includes('gauntlet') || item.toLowerCase().includes('glove') ? '🧤' : item.toLowerCase().includes('key') ? '🗝️' : '📦'} {item}
                    </div>
                  )) : <p style={{ fontSize: '0.65rem', color: 'var(--text-dim)' }}>No items yet.</p>}
                  {p.gold > 0 && <div style={{ fontSize: '0.7rem', color: '#d4af37', marginTop: '6px' }}>💰 {p.gold} gold</div>}
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className="mobile-tabs">
        <button className={tab === 'players' ? 'active' : ''} onClick={() => setTab('players')}>⚔️ Party</button>
        <button className={tab === 'enemies' ? 'active' : ''} onClick={() => setTab('enemies')}>👹 Foes</button>
        <button className={tab === 'actions' ? 'active' : ''} onClick={() => setTab('actions')}>🎯 Actions</button>
        <button className={tab === 'backpack' ? 'active' : ''} onClick={() => setTab('backpack')}>🎒</button>
        <button className={tab === 'console' ? 'active' : ''} onClick={() => setTab('console')}>💬 Console</button>
      </div>
    </div>
  );
}
